import React from 'react';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import { Avatar, Box, Button, Card, CardActions, CardContent, colors, Typography} from '@mui/material';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FactCheckIcon from '@mui/icons-material/FactCheck';

  const publications = [
    {
      title: 'Press Release',
      subtitle: 'Explore the list of OCPF Press Releases by year since 1997.',
      icon: (
        <NewspaperIcon fontSize="large" />
      ),
      color: colors.blue,
      link: '/Publications/pressReleases'
    },
    {
      title: 'OCPF Studies',
      subtitle: 'Find the studies of campaign finance activity by various types of candidates and committees.',
      icon: (
        <LibraryBooksIcon fontSize="large" />
      ),
      color: colors.green,
      link: '/Publications/studies'
    },
    {
      title: 'Guides and Fact Sheets',
      subtitle: 'OCPF issues various publications to help candidates, committees, public employees and others understand the campaign finance law',
      icon: (
        <FactCheckIcon fontSize="large" />
      ),
      color: colors.amber,
      link: '/Publications/factSheets'
    },
  ];

const PublicationList = (): JSX.Element => {

    const theme = useTheme();

    const renderContent = (title: string, subtitle: string, icon: any, color: any, link: string) => (
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
          <Box
            component={Avatar}
            bgcolor={color[100]}
            color={color[900]}
            marginBottom={1}
            width={60}
            height={60}
          >
            {icon}
          </Box>
          <Typography variant={'h6'} fontWeight={700} align={'center'} gutterBottom>
            {title}
          </Typography>
          <Typography color={'text.secondary'} align={'center'}>
            {subtitle}
          </Typography>
          <Box
            paddingY={1 / 2}
            paddingX={1}
            borderRadius={2}
            marginTop={2}
          >
            <Button aria-label={'learn more about '+title} title={'learn more about '+title}size="large" href={link}>Learn More</Button>
          </Box>
        </Box>
      );

    return (
    <Box marginTop={5} marginBottom={5}>
        <Box marginBottom={3}>
        <Typography
         variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          data-aos={'fade-up'}
          fontWeight={700}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          OCPF Press Room
        </Typography>
        </Box>
        <Grid container spacing={4}>
        {publications.map((item, i) => (
          <Grid size={{xs:12, md:4}} key={i}>
            <Card           
             data-aos={'fade-up'}
             data-aos-delay={i * 100}
             data-aos-offset={100}
             data-aos-duration={600}
             sx={{
                borderTop: `2px solid ${item.color[900]}`,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                width: '100%',
                height: '100%',
              }}
            >
              <CardContent sx={{ padding: 3 }}>
                {renderContent(
                  item.title,
                  item.subtitle,
                  item.icon,
                  item.color,
                  item.link
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
    )
}

export default PublicationList;